// ==========================================
// NavBar.jsx - Top Navigation
// ==========================================

import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import styles from "../assets/styles/NavBar.module.css";

function NavBar() {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navLinks}>
        {isAuthenticated ? (
          <>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Home
            </NavLink>
            <NavLink
              to="/product-details"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Product Details
            </NavLink>
            <NavLink
              to="/form-display"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Form Display
            </NavLink>
            <NavLink
              to="/gallery"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Gallery
            </NavLink>
          </>
        ) : (
          <>
            <NavLink
              to="/login"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Login
            </NavLink>
            <NavLink
              to="/signup"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Sign Up
            </NavLink>
          </>
        )}
      </div>

      {isAuthenticated && user && (
        <div className={styles.userSection}>
          <span className={styles.username}>👤 {user.username}</span>
          <button onClick={handleLogout} className={styles.logoutButton}>
            Logout
          </button>
        </div>
      )}
    </nav>
  );
}

export default NavBar;
